import { appConstants } from '../../../constants'

const initialState = {
  dataUser: {},
  loading: false,
  message: null,
  redirect: false
}

export const reducerAuth = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.LOGIN_SUCCESS :
      return {
        ...state,
        dataUser: { ...action.payload.dataUser },
        loading: false,
        redirect: true
      }
    case appConstants.LOGIN_REQUEST :
      return {
        ...state,
        loading: true
      }
    case appConstants.LOGOUT_USER : 
      return {
        ...state,
        dataUser: {},
        redirect: false
      }
    default :
      return state
  }
}